import { Props as ButtonProps } from 'components/layout/Button';

import Component from './component';

export interface Props {
    title?:string;
    input: {
        label: string;
        placeholder: string;
    }
    buttonProps: ButtonProps;
    onSuccess?: (response: any) => any;
    button: {
        label1: string;
        label2: string;
        label3: string;
        label4: string;
    },
    categoryProps: ButtonProps;
    initialValues?: {
        search?: string;
    }
}

Component.defaultProps = {
    onSuccess: null,
    initialValues: {},
};

export default Component;